import { register } from '../../../Utils'

const SectionMenu = el => {
  const stickySection = el.querySelector('[data-sticky]')
  const headerElement = document.querySelector('[data-component="Header"]')
  const links = el.querySelectorAll('[data-link]')
  let headerHeight = headerElement.offsetHeight
  const stickyHeight = stickySection.offsetHeight
  let navPosition = 5000
  el.style.height = `${stickyHeight}px`
  const accTrigger = el.querySelector('.section-menu-acc-trigger')
  const accContent = el.querySelector('.section-menu-acc-content')
  accContent.style.top = `${stickyHeight}px`

  window.addEventListener('scroll', () => {
    stickySection.classList.toggle(`is--sticky`, (window.scrollY + headerHeight + 40) >= navPosition)
  })

  const scrollToSection = (e) => {
    e.preventDefault()

    const targetElement = document.getElementById(e.target.dataset.linkTarget)
    const y = targetElement.getBoundingClientRect().top + window.pageYOffset - 200
    window.scrollTo({ top: y, behavior: 'smooth' })

    accContent.classList.remove('is--open')
    accTrigger.classList.remove('is--open')
  }

  links.forEach(link => {
    link.addEventListener('click', scrollToSection)
  })

  const triggerAccordion = () => {
    accContent.classList.toggle('is--open')
    accTrigger.classList.toggle('is--open')
  }

  if (typeof(accTrigger) != 'undefined' && accTrigger != null) {
    accTrigger.addEventListener('click', triggerAccordion)
  }

  window.addEventListener('load', () => {
    navPosition = el.getBoundingClientRect().top + window.pageYOffset

    window.headerHeight.registerListener((value) => {
      headerHeight = value
      stickySection.style.top = `${(value-1)}px`
    })
  })
}

register('SectionMenu', SectionMenu)
